import { InjectionToken } from '@angular/core';
import { DeviceBaseType, DeviceInfoPayload } from '@bcf-vanilla-ts-v1-utilities/device-info/types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DEVICE_BASE_KIND: InjectionToken<DeviceBaseType> = new InjectionToken<DeviceBaseType>('deviceBaseKind');

// this token should be use only on UI
// eslint-disable-next-line @typescript-eslint/naming-convention
export const DEVICE_INFO: InjectionToken<DeviceInfoPayload> = new InjectionToken<DeviceInfoPayload>('deviceInfo');
